<template>
  <el-transfer
    class="ui-transfer"
    :class="{ 'is-stacked': isStacked }"
    :value="value"
    :data-value="serializedValue"
    v-bind="localizedAttrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event)"
    @change="handleChange"
  >
    <!-- 只转发业务组件真实提供的作用域插槽；不能声明空的 default 插槽，否则 Element 会停用内置标签渲染。 -->
    <template v-for="slotName in scopedSlotNames" v-slot:[slotName]="scope">
      <slot :name="slotName" v-bind="scope" />
    </template>
  </el-transfer>
</template>

<script>
export default {
  name: 'UiTransfer',
  inheritAttrs: false,
  props: {
    value: { type: Array, default: () => [] }
  },
  data () {
    return {
      isStacked: false,
      resizeObserver: null
    }
  },
  computed: {
    localizedAttrs () {
      const attrs = { ...this.$attrs }
      const labelKey = (attrs.props && attrs.props.label) || 'label'
      if (Array.isArray(attrs.data)) attrs.data = attrs.data.map(item => ({ ...item, [labelKey]: this.$t(item[labelKey]) }))
      return attrs
    },
    serializedValue () {
      return JSON.stringify(this.value)
    },
    scopedSlotNames () {
      return Object.keys(this.$scopedSlots)
    },
    forwardedListeners () {
      const listeners = { ...this.$listeners }
      delete listeners.input
      delete listeners.change
      return listeners
    }
  },
  methods: {
    handleChange (...args) {
      this.$emit('change', ...args)
    },
    syncLayout () {
      this.isStacked = Boolean(this.$el && this.$el.getBoundingClientRect().width < 360)
    }
  },
  mounted () {
    this.syncLayout()
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.syncLayout())
      this.resizeObserver.observe(this.$el)
    } else {
      window.addEventListener('resize', this.syncLayout)
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) this.resizeObserver.disconnect()
    else window.removeEventListener('resize', this.syncLayout)
  }
}
</script>

<!-- 面板和内部控件外观统一在 src/styles/selection-controls.scss。 -->
